module.exports = __webpack_public_path__ + "static/sprite-2bf4b5be2de5c7302ffb094fb8b207e4.svg";